/* eslint-disable */
import { useContext, useState } from "react";

import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { useAppDispatch } from "../../store/store";
import { forgotPassword } from "../../store/authSlice";
import { LocalizationContext } from "../../App";
import { ForgotPasswordRequest } from "../../models/request/forgotPasswordRequest";
import { AuthLayout } from "../../layout/AuthLayout";
import { InfoCircle } from "../../common/icons";

const schema = yup.object().shape({
  email: yup.string().required("Email is required"),
});

function ForgotPassword() {
  const actionDispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [showEmailSentMessage, setShowEmailSentMessage] = useState(false);
  const l10n = useContext(LocalizationContext);

  const onSubmit = (data: any) => {
    let request = new ForgotPasswordRequest();
    request.email = data.email;
    actionDispatch(forgotPassword({ request: request }));
    setShowEmailSentMessage(true);
  };

  return (
    <AuthLayout>
      <form
        className="h-full flex-1 flex flex-col justify-between items-stretch landscape:pb-8"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div>
          <h2>{l10n.title.resetPassword}</h2>
          <div className="form-group">
            <label htmlFor="email">{l10n.label.yourEmail}</label>
            <input
              className="form-control"
              id="email"
              placeholder="Your email address" // TODO: Add proper placeholder
              type="email"
              {...register("email")}
            />
            {errors.email && <p className="invalid-feedback">{errors.email.message}</p>}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <button className="btn btn-primary mb-0" type="submit">
            {l10n.label.resetPassword}
          </button>
          {showEmailSentMessage && (
            <div className="notification notification-info">
              <InfoCircle className="w-[24px] h-[24px] shrink-0 fill-info" />
              <span>{l10n.notice.pleaseCheckEmail}</span>
            </div>
          )}
          <button className="btn btn-secondary" type="button">
            <Link to="/login">{l10n.btn.backToLogin}</Link>
          </button>
        </div>
      </form>
    </AuthLayout>
  );
}

export default ForgotPassword;
